import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

interface ObjectWithDate {
  [date: string]: string;
}

@Pipe({
  name: 'orderByDate'
})
export class OrderByDatePipe implements PipeTransform {
  transform(xs: ObjectWithDate[], order: 'asc' | 'desc' = 'asc'): ObjectWithDate[] {
    return xs.sort((a: ObjectWithDate, b: ObjectWithDate) => {
      return order === 'asc'
        ? +new Date(a.date) - +new Date(b.date)
        : +new Date(b.date) - +new Date(a.date);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/list/order-by-date.pipe.ts